import { useRef, useEffect } from 'react'
import sha from 'sha1'
import { useRouter } from 'next/router'

const NAMESPACE = '1b671a64-40d5-491e-99b0-da01ff1f3341'
const DELI = '|'

function historyStack() {
  if (typeof window === 'undefined') {
    return []
  }
  const hash = window.location.hash
  return hash
    .replace('#', '')
    .split(DELI)
    .filter(v => !!v)
}

function hasHistory(pageId: string) {
  return historyStack().includes(pageId)
}

const usePreventBack = (rootPage: string, cb: () => void) => {
  const pageId = useRef(sha(rootPage + NAMESPACE).substr(0, 4)).current
  const router = useRouter()

  function pushHistory(pageId: string) {
    const hashStack = historyStack()
    const { pathname, search = '' } = location
    const hash = `#${[...hashStack, pageId].filter(v => v).join(DELI)}`
    router
      .push({
        pathname,
        search,
        hash,
      })
      .catch(e => {
        if (!e.cancelled) {
          throw e
        }
      })
  }

  useEffect(() => {
    if (hasHistory(pageId)) {
      const { pathname, search = '' } = location
      router
        .replace({
          pathname,
          search,
        })
        .then(() => pushHistory(pageId))
        .catch(e => {
          if (!e.cancelled) {
            throw e
          }
        })
    } else {
      pushHistory(pageId)
    }
  }, [])

  const handlePopState = () => {
    const isCurrentPage = location.pathname === rootPage
    if (isCurrentPage && !historyStack().length) {
      cb()
    }
  }

  useEffect(() => {
    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [])

  return {
    pageId,
  }
}

export default usePreventBack
